module.exports = __webpack_public_path__ + "img/金属材料学3_6_5.b0106d94.png";